import getAppLayout from './getAppLayout'
import getEnvLayout from './getEnvLayout'

const { hostname } = window.location
const layout = getAppLayout(hostname)
const envLayout = getEnvLayout(layout.name)

const getCommonEnv = envKey => {
  const envName = envKey.replace('REACT_APP', `REACT_APP${envLayout}`)
  if (process.env[envName]) {
    return process.env[envName]
  }

  return undefined
}

export default getCommonEnv
